import styles from './styles.module.scss';
import { RouletteProps, RouletteType } from './props';
import { useMemo } from 'react';
import RoulettePrize from './Prize';
import { useRoulette } from '@starsoft/common/hooks';

export default function Roulette<T>({
  customCard,
  onPrizeDefined,
  prizeIndex,
  prizes,
  spinningTime,
  start,
  firstItem,
  hideCenterPin,
  type = RouletteType.Default,
  isPaperColor,
  isTransparent,
  centerSpin,
}: RouletteProps<T>) {
  const { containerRef } = useRoulette({
    prizeIndex,
    spinningTime,
    start,
    firstItem,
    callback: onPrizeDefined,
    type,
  });

  const Cards = useMemo(
    () =>
      prizes.map((prize, index) => (
        <RoulettePrize
          customCard={customCard}
          data={prize}
          position={index}
          key={`roulette-prize-${index}`}
        />
      )),
    [prizes, customCard],
  );

  return (
    <div
      className={`${styles.container} ${isPaperColor ? styles['container--paper'] : ''} ${isTransparent ? styles['container--transparent'] : ''}`}
    >
      <div className={styles.container__wrapper}>
        <div className={styles.container__wrapper__list} ref={containerRef}>
          {Cards}
        </div>
      </div>
      {!hideCenterPin && <div className={styles.container__wrapper__pin} />}
      {centerSpin && centerSpin}
    </div>
  );
}
